import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../controls/employee-report-selection-control.component";
import {ReportData} from "../../../../reports/report.data";

export class EmployeeTimeCardReportData extends ReportData<EmployeeTimeCardReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
    @field includeCost: boolean = false;
}
